import { render, staticRenderFns } from "./RemarkCreateAndList.vue?vue&type=template&id=621884c9&scoped=true&"
import script from "./RemarkCreateAndList.vue?vue&type=script&lang=js&"
export * from "./RemarkCreateAndList.vue?vue&type=script&lang=js&"
import style0 from "./RemarkCreateAndList.vue?vue&type=style&index=0&id=621884c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621884c9",
  null
  
)

export default component.exports